import React, { useMemo } from "react";
import { Autocomplete, Box } from "@mui/material";

import { ReactComponent as ArrowdownIcon } from "../../../../vendor/_new/icon/sites/arrow_down.svg";
import { SafeTextField } from "../../../common/Greens";
import colors from "../../../../utils/colors";

export const NONE_PROJECT = { id: "__none__", name: "None" };

export function getProjectSelectLabel(option) {
  if (!option || option.id === NONE_PROJECT.id) return "None";
  return option.name || option.id || "";
}

export function resolveProjectSelectOption(projectList, projectId) {
  if (!projectId) return NONE_PROJECT;
  const match = (projectList || []).find((item) => item?.id === projectId);
  if (match) return match;
  return { id: projectId, name: projectId };
}

export function projectIdFromOption(option) {
  if (!option || option.id === NONE_PROJECT.id) return "";
  return option.id ?? "";
}

/** Show all options until the user types something other than the closed-field label. */
export function filterProjectSelectOptions(options, inputValue, selectedLabel) {
  const query = String(inputValue || "").trim().toLowerCase();
  const selected = String(selectedLabel || "").trim().toLowerCase();
  if (!query || query === selected) return options || [];
  return (options || []).filter((option) => getProjectSelectLabel(option).toLowerCase().includes(query));
}

const AddSiteProjectSelect = ({ projectList, value, onChange, disabled = false, listMaxHeight = 280 }) => {
  const options = useMemo(() => [NONE_PROJECT, ...(projectList || []).filter((item) => item?.id)], [projectList]);
  const resolved = resolveProjectSelectOption(projectList, value);
  const selectedLabel = getProjectSelectLabel(resolved);

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      options={options}
      value={resolved}
      disableClearable
      autoHighlight
      popupIcon={<ArrowdownIcon />}
      noOptionsText="No matching projects"
      isOptionEqualToValue={(a, b) => a?.id === b?.id}
      getOptionLabel={getProjectSelectLabel}
      filterOptions={(opts, state) => filterProjectSelectOptions(opts, state.inputValue, selectedLabel)}
      onChange={(_, option) => onChange(projectIdFromOption(option))}
      ListboxProps={{ sx: { maxHeight: listMaxHeight } }}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            height: 38,
            fontSize: 14,
            lineHeight: "21px",
            color: colors.neutral[1000],
            "&:hover": { color: colors.primary[300] },
          }}
        >
          {getProjectSelectLabel(option)}
        </Box>
      )}
      renderInput={(params) => <SafeTextField {...params} sanitize={false} label="Select project (optional)" />}
    />
  );
};

export default AddSiteProjectSelect;
